<template>

  <div class="join-stage-page notification-blk">
    <Header></Header>
    <section class="join-stage" v-if="lists2.length">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>Notification for New Stage</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 join-stage-container">
            <Loader v-if="loading" />
            <div class="row join-stage-row" v-for="(list) in lists2" v-bind:key="list._id">
              <div class="col-md-12">
                <div class="stage-content">
                  <h4>{{list.created | formatDate}}</h4>
                  <h3><router-link :to="`/stage/`+list.stage._id" style="color: #5B3C51;">{{list.stage.title}}</router-link></h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="join-stage" v-if="lists.length">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>Notification for Approval</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 join-stage-container">
            <Loader v-if="loading" />
            <div v-if="!loading" class="row join-stage-row" v-for="(list) in lists" v-bind:key="list._id">
              <div class="col-md-8">
                <div class="stage-content">
                  <h4>{{list.created | formatDate}}</h4>
                  <h2><router-link :to="`/artists/`+list.appliedArtist._id">{{list.appliedArtist.name}}</router-link> applied for role of {{list.role.role}} <span v-if="list.role.specialty">- {{list.role.specialty}}</span> - <span v-if="list.role.remote">Remote</span><span v-if="!list.role.remote">Local</span></h2>
                  <h3><router-link :to="`/stage/`+list.stage._id">{{list.stage.title}}</router-link></h3>
                </div>
              </div>
              <div class="col-md-4 join-stage-col-2 text-right">
                <router-link :to="`/artists/`+list.appliedArtist._id+`/message`">Message</router-link>
                <a href="javascript:void(0)" v-on:click="responseAction" data-action="accept" :data-stageId="list.stage._id" :data-id="list._id" :data-roleId="list.role._id" :data-artistId="list.appliedArtist._id">Accept</a>
                <a href="javascript:void(0)" v-on:click="responseAction" data-action="decline" :data-stageId="list.stage._id" :data-id="list._id" :data-roleId="list.role._id" :data-artistId="list.appliedArtist._id">Decline</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="join-stage">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>Notification for Stages</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 join-stage-container">
            <Loader v-if="loading" />
            <h2 v-if="!lists1.length" style="padding: 50px;font-size: 23px;">NO Notifications</h2>
            <div v-if="!loading && lists1.length && list.role" class="row join-stage-row" v-for="(list) in lists1" v-bind:key="list._id">
              <div class="col-md-12">
                <div class="stage-content">
                  <h4>{{list.created | formatDate}}</h4>
                  <h2 v-if="list.response == 'pending'">Pending Response</h2>
                  <h2 v-if="list.response == 'decline'">Unfortunately, you have not been accepted to be the {{list.role.role}} by <router-link :to="`/artists/`+list.stageOwner._id">{{list.stageOwner.name}}</router-link>.</h2>
                  <h2 v-if="list.response == 'accept'">Congratulations, you have been accepted to be the {{list.role.role}} by <router-link :to="`/artists/`+list.stageOwner._id">{{list.stageOwner.name}}</router-link>.</h2>
                  <h3><router-link :to="`/stage/`+list.stage._id">{{list.stage.title}}</router-link></h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'
import $ from "jquery"
import Loader from './include/Loader'
import axios from 'axios'
import backgroundUrl from '@/assets/img/image6.jpg'
import Vue from 'vue'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
Vue.use(VueToast)
export default {
  name: 'Notification',
  components: {
    'Header': Header,
    'Footer': Footer,
    'Loader': Loader
  },
  mounted () {
      var userData = localStorage.getItem('cbs_usertoken')
      if(userData){
          userData = JSON.parse(userData)
          axios
              .get('/getNotificationForApproval', {
                  params: {
                      userId: userData.user.id
                  }
              })
              .then(response => {
                  this.loading = false
                  this.lists = response.data
                  console.log(response.data)
              })
              .catch(error => console.log(error))
          axios
              .get('/getNotificationForArtist', {
                  params: {
                      userId: userData.user.id
                  }
              })
              .then(response => {
                  this.loading = false
                  this.lists1 = response.data
                  console.log('list1', response.data)
              })
              .catch(error => console.log(error))
          axios
              .get('/getNotificationForNewStage', {})
              .then(response => {
                  this.lists2 = response.data
                  this.loading = false
              })
              .catch(error => console.log(error))
      }
  },
    methods: {
        checkboxFuntion: function (event) {
            $(event.target).toggleClass('active')
        },
        responseAction: function (event) {
            axios.post('/updateNotificationResponse', {
                id: event.target.dataset.id,
                response: event.target.dataset.action,
                roleId: event.target.dataset.roleid,
                artistId: event.target.dataset.artistid,
                stageId: event.target.dataset.stageId
            },{
                headers: {
                    "content-type": "application/json",
                    "x-api-key": this.userData.token
                }
            }).then(function (response) {
                $(event.target).closest('.join-stage-row').addClass('disabled-notification')
                Vue.$toast.open(
                    {
                        message: 'Submitted Successfully',
                        type: 'success',
                        position: 'top-right'
                        // all other options
                    }
                )
            })
        }
    },
  data () {
      var userdata = localStorage.getItem('cbs_usertoken')
      if(userdata){
          userdata = JSON.parse(userdata)
      }
    return {
        backgroundUrl: backgroundUrl,
        checkboxActive: '',
        imageUrl: process.env.imageUrl,
        loading: true,
        lists2: [],
        userData: userdata,
        msg: 'Welcome to Your Vue.js App',
        lists: [],
        lists1: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Notification.vue